import React, { useCallback } from 'react';
import { Input } from 'antd';
import { useDispatch } from 'react-redux';
import debounce from 'lodash/debounce';
import HideShowMenuSwitch from '../../layout/hideShowMenuSwitch';

const Toolbar = ({ load, resource, page, handleSelectChange, stateFilterOptions, statePagination }) => {
    const dispatch = useDispatch();

    const refreshPage = () => {
        dispatch(load(resource, page, stateFilterOptions, statePagination));
    };

    const debouncedSearch = useCallback(
        debounce((value) => handleSelectChange(value, 'searchText'), 500),
        [handleSelectChange]
    );

    const onSearchChange = (e) => {
        debouncedSearch(e.target.value.toLowerCase());
    };

    return (
        <div className="toolbar__container">
            <div className="toolbar__container_left">
                <div className="button accent" style={{ alignSelf: 'center' }} onClick={refreshPage}>Refresh</div>
                <Input
                    className="input__search"
                    onChange={onSearchChange}
                    placeholder="Search"
                    type="text"
                    allowClear
                />
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <HideShowMenuSwitch />
            </div>
        </div>
    );
};

export default React.memo(Toolbar);
